import type { FC, PropsWithChildren } from 'react'

import { HeroUIProvider } from '@heroui/system'
import { ToastProvider } from '@heroui/toast'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { createRootRoute, Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { NuqsAdapter } from 'nuqs/adapters/react'

import { IS_DEV } from '@/app/config/consts'
import { LangProvider } from '@/shared/i18n'
import { QueryClientProvider } from '@/shared/lib/query'

export const RootProviders: FC<PropsWithChildren> = ({ children }) => (
  <LangProvider>
    <NuqsAdapter>
      <QueryClientProvider>
        <HeroUIProvider>
          <ToastProvider placement="top-right" />
          <main className="min-h-dvh">{children}</main>
        </HeroUIProvider>
        {IS_DEV && (
          <>
            <ReactQueryDevtools position="bottom" buttonPosition="bottom-left" />
            <TanStackRouterDevtools position="bottom-left" />
          </>
        )}
      </QueryClientProvider>
    </NuqsAdapter>
  </LangProvider>
)

export const Route = createRootRoute({
  component: RootComponent,
})

function RootComponent() {
  return (
    <RootProviders>
      <Outlet />
    </RootProviders>
  )
}
